export const enum ImportDialogView {
    None = 1,
    SelectFile,
    ConfirmEncoding,
    UploadFile,
    Error,
    Completed,
}

export interface ImportContactsState {
    readonly dialogView: ImportDialogView;
    readonly importedCount: number;
    readonly requestedCount: number;
    readonly errorMessage: string;
    readonly lastImportRequestTimestamp: number;
    readonly csvBytes: Uint8Array;
    readonly csvEncodingExamples: string[][];
}

export const packageStateKey = 'importcontacts';
